/**
 * @generated SignedSource<<02ca3198e5fd7f1d06d458bae70cad91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type QueriesUserAppPermissionsQuery$variables = {};
export type QueriesUserAppPermissionsQuery$data = {
  readonly user: {
    readonly email: string;
    readonly firstName: string;
    readonly id: string;
    readonly lastName: string;
    readonly roles: {
      readonly totalCount: number | null;
    };
  } | null;
};
export type QueriesUserAppPermissionsQuery = {
  response: QueriesUserAppPermissionsQuery$data;
  variables: QueriesUserAppPermissionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNode",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "active",
            "value": true
          },
          {
            "kind": "Literal",
            "name": "role",
            "value": "A_5"
          }
        ],
        "concreteType": "UserAppPermissionNodeConnection",
        "kind": "LinkedField",
        "name": "roles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          }
        ],
        "storageKey": "roles(active:true,role:\"A_5\")"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "QueriesUserAppPermissionsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "QueriesUserAppPermissionsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4853477d0000fe738d31b6e22fd8946e",
    "id": null,
    "metadata": {},
    "name": "QueriesUserAppPermissionsQuery",
    "operationKind": "query",
    "text": "query QueriesUserAppPermissionsQuery {\n  user {\n    id\n    email\n    firstName\n    lastName\n    roles(active: true, role: A_5) {\n      totalCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bf576f6511f49ae3ec0fd0fdaea7b2a0";

export default node;
